export const postMessageTo = (
    type: string,
    data: any,
    target: Window = window.parent
) => target.postMessage({ source: "inPoint", type, data }, "*");
